<template>
  <MainPage>
    <form class='page-login-form'>
      <div class='logo-arvalis'/>
      <div class='wrap'>
        <label for='password'>Votre nouveau mot de passe :</label>
        <input v-focus v-model='mdp' type='password' name='mdp' id='password' required placeholder='Nouveau mot de passe' />
        <password-meter :password="mdp" />
        <span v-if="!pwdValid" class="form-error-pwd">Choisissez au moins 8 caractères dont 1 majuscule, 1 chiffre et 1 caractère spécial.</span>
      </div>
      <div class="ct-flex-row ct-jc-space">
        <input type='button' class="primary-action" @click="changePwd" name='changePwd' value='Modifier' :disabled="!pwdValid">
        <input type='button' class="secondary-action" @click="$router.push('/login')" value="Retour" />
      </div>
    </form>
  </MainPage>
</template>

<script>
import MainPage from './MainPage'
import { mapActions } from 'vuex'
import passwordMeter from 'vue-simple-password-meter'

export default {
  name: 'changePassword',

  props: {
    token: {
      type: String,
      require: true
    }
  },

  components: {
    passwordMeter,
    MainPage
  },

  data () {
    return {
      mdp: '',
      pwdValid: false
    }
  },
  methods: {
    ...mapActions(['changePassword']),

    changePwd () {
      this.changePassword({
        token: this.token,
        password: this.mdp
      })
        .then(response => {
          if (response.status === 'changed') {
            this.$store.dispatch('success', { message: 'Le mot de passe a été changé avec succès.' })
            this.$router.push({ name: 'login' })
          } else {
            this.$store.dispatch('error', { message: response.message })
          }
        })
        .catch(() => {
          alert('Une erreur est survenue.')
        })
    }
  },

  watch: {
    mdp: function () {
      let regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/
      this.pwdValid = regexp.test(this.mdp)
    }
  }
}
</script>
